import React, { useState } from "react";
import ReactCrop from "react-image-crop";
import PropTypes from "prop-types";
import "react-image-crop/dist/ReactCrop.css";

function ImageCropper({ imageToCrop, onImageCropped, rotation }) {
  const [cropConfig, setCropConfig] = useState({
    unit: "%",
    width: 30,
    aspect: 1,
  });
  const [imageRef, setImageRef] = useState();

  async function getCroppedImage(sourceImage, crop, rotation) {
    return new Promise((resolve, reject) => {
      const canvas = document.createElement("canvas");

      const ctx = canvas.getContext("2d");

      const scaleX = sourceImage.naturalWidth / sourceImage.width;
      const scaleY = sourceImage.naturalHeight / sourceImage.height;

      // Calculate the canvas size considering rotation
      const canvasWidth = rotation % 180 === 0 ? crop.width : crop.height;
      const canvasHeight = rotation % 180 === 0 ? crop.height : crop.width;

      canvas.width = canvasWidth;
      canvas.height = canvasHeight;

      // Apply rotation if needed
      if (rotation !== 0) {
        ctx.translate(canvas.width / 2, canvas.height / 2);
        ctx.rotate((rotation * Math.PI) / 180);
      }

      // Draw the cropped image onto the canvas
      ctx.drawImage(
        sourceImage,
        crop.x * scaleX,
        crop.y * scaleY,
        crop.width * scaleX,
        crop.height * scaleY,
        -canvas.width / 2, // Offset the image to ensure it's centered after rotation
        -canvas.height / 2,
        canvasWidth,
        canvasHeight
      );

      // Convert the canvas content to a blob
      canvas.toBlob((blob) => {
        if (!blob) {
          reject(new Error("Canvas is empty"));
          return;
        }
        resolve({ blob, imgSrc: window.URL.createObjectURL(blob) });
      }, "image/jpeg");
    });
  }

  async function cropImage(crop) {
    if (imageRef && crop.width && crop.height) {
      const croppedImage = await getCroppedImage(imageRef, crop);
      onImageCropped(croppedImage);
    }
  }

  const rotationStyle = {
    transform: `rotate(${rotation}deg)`,
  };

  return (
    <div style={rotationStyle}>
      <ReactCrop
        src={imageToCrop}
        crop={cropConfig}
        ruleOfThirds
        onImageLoaded={(imageRefProp) => setImageRef(imageRefProp)}
        onComplete={(cropConfigProp) => cropImage(cropConfigProp)}
        onChange={(cropConfigProp) => setCropConfig(cropConfigProp)}
        crossorigin="anonymous"
      />
    </div>
  );
}

ImageCropper.propTypes = {
  onImageCropped: PropTypes.func.isRequired,
  imageToCrop: PropTypes.string.isRequired,
  rotation: PropTypes.number.isRequired,
};

ImageCropper.defaultProps = {
  imageToCrop: "",
  onImageCropped: () => {},
  rotation: 0,
};

export default ImageCropper;
